function filter(layout, recordLayouts) {
  return layout.reduce(function (acc, item) {
    var id = item.id,
      type = item.type;
    var matches = recordLayouts.reduce(function (acc, recordLayout) {
      var found = recordLayout.find(function (item) {
        return item.id === id;
      });
      if (found) {
        acc.push(found);
      }
      return acc;
    }, []);
    if (matches.length > 0) {
      if (type === 'group') {
        var children = filter(item.children, matches.map(function (match) {
          return match.children;
        }));
        if (children.length > 0) {
          acc.push(Object.assign({}, item, {
            children: children
          }));
        }
      } else if (type === 'field' || type === 'array') {
        acc.push(item);
      }
    }
    return acc;
  }, []);
}
export default function filterLayoutToVisibleFromRecords(layout, records) {
  return filter(layout, records.map(function (record) {
    return record.layout;
  }));
}